module.exports = __webpack_public_path__ + "static/img/6101_phase_function_Paper_Points.13d5886.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6101_phase_function_Paper_Points.png
// module id = Vwey
// module chunks = 0